
function sliders(){

    (function($) {

        $('.title-animation').css('opacity', 1);

           
                $('.title-animation').textillate({
                    loop: false,
                    minDisplayTime: 1000,
                    autoStart: true,
                    in: {
                        effect: 'wobble',
                        delayScale: 1.5,
                        delay: 100,
                        sync: false,
                        shuffle: false,
                        reverse: false,
                    },

                    type: 'char'

                });
         


            $('.full-slideshow').slick({
                infinite: true,
                dots: false,
                prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Previous</span></button>',
                nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Next</span></button>',
                edgeFriction: 0,
                pauseOnFocus: false,
                pauseOnHover: false,
                speed: 400,
                autoplay: true,
                autoplaySpeed: 5000,
                fade: false,
            });



            $('.full-slideshow').on('beforeChange', function(){
                $('.full-slideshow .title-animation').textillate('start');
            });




        
    })
    (jQuery);
}